var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angular-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#f77c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#f77c7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "angular",
    transform: "translate(262.081 -532.207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(-242.823 554.082)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M-219.365,571.327l-1.137,9.825a.7.7,0,0,1-.341.523l-6.232,3.434a.681.681,0,0,1-.66,0l-6.209-3.434a.7.7,0,0,1-.341-.523l-1.137-9.825a.692.692,0,0,1,.455-.728l7.346-2.615a.774.774,0,0,1,.455,0l7.346,2.615A.667.667,0,0,1-219.365,571.327Z",
    transform: "translate(235.428 -567.95)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(-243.752 550.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M-229.342,576.072a.606.606,0,0,1-.273-.068l-8.142-4.526a.588.588,0,0,1-.3-.432l-1.456-12.736a.552.552,0,0,1,.364-.591l9.6-3.434a.564.564,0,0,1,.387,0l9.6,3.434a.542.542,0,0,1,.364.591l-1.456,12.736a.588.588,0,0,1-.3.432L-229.092,576A.459.459,0,0,1-229.342,576.072Zm-7.3-5.276,6.982,3.866a.681.681,0,0,0,.66,0l6.982-3.866a.7.7,0,0,0,.341-.523l1.3-11.121a.692.692,0,0,0-.455-.728l-8.233-2.957a.774.774,0,0,0-.455,0l-8.256,2.957a.719.719,0,0,0-.455.728l1.251,11.121A.628.628,0,0,0-236.643,570.8Z",
    transform: "translate(239.511 -554.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(-238.763 554.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M-207.21,582.974l-4.64-10.894a.677.677,0,0,0-1.251,0l-4.435,10.894a.587.587,0,0,0,.318.75.664.664,0,0,0,.2.046.561.561,0,0,0,.523-.364l1.729-4.23h4.708l1.819,4.253a.551.551,0,0,0,.751.3A.559.559,0,0,0-207.21,582.974Zm-7.1-4.935,1.842-4.526,1.933,4.526Z",
    transform: "translate(217.575 -571.662)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.2218d1625a7fc49b51f52886cd2c8265.svg";
export { ForwardRef as ReactComponent };